export const CurrencyType = {
    EUR: 'EUR',
    GBP: 'GBP',
    KGS: 'KGS',
    KZT: 'KZT',
    PKR: 'PKR',
    TRY: 'TRY',
    TZS: 'TZS',
    USD: 'USD',
} as const;
export type CurrencyType = (typeof CurrencyType)[keyof typeof CurrencyType];

export const CurrencySymbol = {
    EUR: '€',
    GBP: '£',
    KGS: 'som',
    KZT: '₸',
    PKR: 'Rs',
    TRY: '₺',
    TZS: 'TSh',
    USD: '$',
} as const;
export type CurrencySymbol = (typeof CurrencySymbol)[keyof typeof CurrencySymbol];
